import clsx from 'clsx'
import React from 'react'

import styles from './loading.module.scss'

export const LoadingSpinner = ({ className, ...rest }: React.ComponentProps<'div'>) => (
  <div className={clsx(styles.spinner, className)} {...rest} />
)

export const LoadingOverlay = ({ children, className }: React.ComponentProps<'div'>) => (
  <div className={clsx(styles.overlay, className)}>
    {children}
  </div>
)
